<template>
  <div :class="wrapperClass">
    <label v-for="(option, idx) in formattedOptions" :key="idx" :for="`radio-${idx}-${shortid}`" :class="{
      [labelClass]: true,
      [labelBgClass(option)]: true,
      'border-none': idx === formattedOptions.length - 1
    }">
      <span v-if="variant === 'radio'" class="inline-flex justify-center items-center w-5 h-5 border-2 rounded-full"
        :class="[option.value === value ? 'bg-primary border-primary' : 'bg-white border-grey-200']">
          <span class="w-2 h-2 bg-white rounded-full"></span>
      </span>
      <span v-if="variant === 'check'" class="flex-none h-6 w-6 flex items-center justify-center rounded-md border" :class="{
        'bg-primary border-primary text-primary-invert': option.value === value,
        'bg-white border-grey-200': option.value !== value
      }">
        <tick-icon v-if="option.value === value" class="fill-current"></tick-icon>
      </span>
      <input type="radio" :id="`radio-${idx}-${shortid}`" class="hidden" :value="radioValue" @click="(
      ) => (radioValue = option.value)
        " />
      {{ formatLabel(option.text) }}
    </label>
  </div>
</template>

<script>
import shortid from 'shortid';
import { twJoin } from 'tailwind-merge';
import TickIcon from '../assets/check.svg';

export default {
  name: 'Radio',
  components: { TickIcon },
  props: {
    value: {},
    options: {
      type: Array,
      required: true
    },
    variant: {
      type: String,
      default: 'box',
      validator: val => ['radio', 'box', 'tab', 'darkTab', 'check'].includes(val)
    },
    toggle: {
      type: Boolean,
      default: false
    },
    formatLabel: {
      type: Function,
      default: value => value
    }
  },
  data() {
    return {
      shortid: shortid.generate()
    };
  },
  computed: {
    formattedOptions() {
      if (!this.options) return [];
      if (this.options[0] && this.options[0].value) return this.options;
      return this.options.map(option => ({ text: option, value: option }));
    },
    radioValue: {
      get() {
        return this.value;
      },
      set(value) {
        const val = this.toggle && value === this.value ? null : value;
        this.$emit('input', val);
        this.$emit('change', val);
      }
    },
    wrapperClass() {
      const baseClass = 'flex flex-wrap w-full rounded-md overflow-hidden';
      const variantClass = {
        radio: 'gap-4',
        box: 'bg-secondary text-secondary-invert',
        tab: 'bg-secondary text-secondary-invert rounded-b-none',
        darkTab: 'gap-1 text-secondary-invert rounded-b-none',
        check: 'flex-col gap-3'
      };
      return twJoin(baseClass, variantClass[this.variant]);
    },
    labelClass() {
      const baseClass = 'cursor-pointer';
      const variantClass = {
        radio: 'flex font-semibold gap-2 items-center text-grey-800',
        box: 'flex-grow p-2 text-center border-r border-secondary-lighter',
        tab: 'flex-grow p-2 text-center border-r border-secondary-lighter',
        darkTab: 'cursor-pointer flex-grow p-2 rounded-t-lg text-center',
        check: 'flex font-semibold gap-3 items-center text-grey-800',
      };
      return twJoin(baseClass, variantClass[this.variant]);
    }
  },
  methods: {
    labelBgClass(option) {
      const variantClass = {
        radio: '',
        box: 'bg-primary',
        tab: 'bg-primary',
        darkTab: 'bg-secondary',
        check: '',
      }
      if (option.value === this.value) {
        return variantClass[this.variant];
      }
      return this.variant === 'darkTab' ? 'bg-secondary-light' : '';
    }
  }
};
</script>
